import { render, staticRenderFns } from "./ResourcesSvg.vue?vue&type=template&id=6c549f1e&scoped=true&"
import script from "./ResourcesSvg.vue?vue&type=script&lang=js&"
export * from "./ResourcesSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c549f1e",
  null
  
)

export default component.exports